<template>
  <database-management-modal :element="department" ref="modal">
    <template v-slot:body>
      <div :class="hasErrorClass($v.department.name, 'form-group')">
        <label class="control-label">* Name</label>

        <input
          name="name"
          type="text"
          class="form-control"
          placeholder="Marketing"
          v-model="$v.department.name.$model" />

        <vuelidate-help :field="$v.department.name" label="Name" />
      </div>

      <div :class="hasErrorClass($v.department.restricted, 'form-group')">
        <div class="checkbox checkbox-primary">
          <div class="input-group-checkbox">
            <input
              type="checkbox"
              id="restricted"
              name="restricted"
              v-model="$v.department.restricted.$model"
            >
            <label for="restricted">
              Show department for restricted admin request forms only
            </label>
            <vuelidate-help :field="$v.department.restricted" label="Restricted" />
          </div>
        </div>
      </div>

    </template>
    <template v-slot:footer>
      <ladda-button :click="saveDepartment" type="button" class="btn btn-lg btn-primary pull-right" data-dismiss="modal"><i class="fa fa-check"></i> Save</ladda-button>
    </template>
  </database-management-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VuelidateHelp from '../../misc/VuelidateHelp'
import { http, notify } from 'utils'
import DatabaseManagementModal from './templates/DatabaseManagementModal'
export default {
  components: {DatabaseManagementModal, VuelidateHelp},

  props: {
    department: {
      required: true
    }
  },

  methods: {
    hasErrorClass (field, classes) {
      return field.$error ? `${classes} has-error` : `${classes}`
    },

    closeModal () {
      this.$refs.modal.closeModal()
    },

    saveDepartment () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }
      if (this.department.id) {
        return http.put(`departments/${this.department.id}/update`, this.department).then((response) => {
          this.$emit('update', response.data)
          this.closeModal()
        })
      }
      return http.post('department', this.department).then((response) => {
        this.$emit('create', response.data)
        this.closeModal()
      })
    }
  },

  validations: {
    department: {
      name: {
        required
      },
      restricted: {
      }
    }
  }
}
</script>
